module.exports = __webpack_public_path__ + "static/media/svg.f8fe7ff5.svg";